<template>
  <v-container>
    <v-row class="pa-0 ma-0">
      <v-col class="col-12 mb-0 pb-0">
        <v-alert type="info" text="">
          This is currently a <b>beta</b> feature. Please email
          <a href="mailto:support@arist.co" target="__email__"
            >support@arist.co</a
          >
          to get a private invite to our Zapier app.
        </v-alert>
        <h1 class="mb-2">Integrations</h1>
      </v-col>
      <v-col class="col-12 col-md-6 col-lg-8">
        <v-card flat="" outlined="">
          <v-card-title>
            <b>Zapier Keys</b>
            <v-spacer />
            <v-btn
              small=""
              rounded=""
              depressed=""
              color="blue"
              class="white--text"
              @click="showCreate = true"
              >Create Key</v-btn
            >
          </v-card-title>
          <div class="pl-4 pr-4">
            <p class="mr-auto ml-auto text-center" v-if="apikeys.length == 0">
              You do not have any Zapier Keys
            </p>
            <v-list>
              <v-list-item
                rounded
                class="pl-0 pr-0 ml-0 mr-0 keyhover"
                v-for="apikey in apikeys"
                :key="apikey._id"
              >
                <v-icon class="mr-5">mdi-key</v-icon>

                <v-list-item-content>
                  <v-list-item-title
                    >********-****-****-****-******{{
                      apikey ? apikey.suffix : ""
                    }}</v-list-item-title
                  >
                  <v-list-item-subtitle class="mt-2"
                    >Last Used:
                    {{
                      !Number.isNaN(new Date(apikey.lastUsed).valueOf())
                        ? new Date(apikey.lastUsed).toLocaleString()
                        : "never"
                    }}</v-list-item-subtitle
                  >
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn icon class="dangerdanger" @click="remove(apikey._id)">
                    <v-icon color="grey lighten-1 icon">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-card>
      </v-col>
      <v-col class="col-12 col-md-6 col-lg-4">
        <v-card flat="" outlined="" height="100%" max-height="200px">
          <v-card-title>
            <b>Organization Information</b>
          </v-card-title>
          <div class="pl-4 pr-4">
            <p class="body-1 d-flex">
              <span class="mr-2"><b>ID:</b></span>
              {{ $store.getters["getOrganization"]._id }}
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col class="col-12">
        <h2 class="mb-4">Zapier Previews</h2>
        <h3>Selecting an event</h3>
        <v-card outlined="" flat="" style="overflow:hidden">
          <v-img
            min-height="100px"
            :src="zapierImage"
            alt="Zapier allows you to select an event to track, either an enrollment or a course completed, through a menu."
          />
        </v-card>
        <h3 class="mt-4">Selecting a course to watch</h3>

        <v-card outlined="" flat="" style="overflow:hidden">
          <v-img
            min-height="100px"
            :src="zapierImage2"
            alt="Zapier allows you to select a published course in a dropdown menu for your classroom."
          />
        </v-card>
      </v-col>
    </v-row>
    <createAPIKey v-model="showCreate" />
  </v-container>
</template>
<style scoped>
.dangerdanger:hover i {
  color: rgb(255, 0, 0) !important;
}
</style>
<script>
import createAPIKey from "./create-api-key";
import services from "@/services";
export default {
  components: {
    createAPIKey
  },
  data: () => ({
    showCreate: false,
    apikeys: [],
    zapierImage: require("@/assets/imgs/Zapier.png"),
    zapierImage2: require("@/assets/imgs/Zapier2.png")
  }),
  methods: {
    async loadAPIKeys() {
      try {
        const keys = await services.apikeys.get();
        this.apikeys = keys;
      } catch (err) {
        console.error("Failed to get API keys", err);
      }
    },
    async remove(id) {
      if (confirm("Are you sure you want to remove this API key?")) {
        await services.apikeys.remove({ key: id });
        this.loadAPIKeys();
      }
    }
  },
  watch: {
    showCreate() {
      if (this.showCreate === false) {
        this.loadAPIKeys();
      }
    }
  },
  mounted() {
    this.loadAPIKeys();
  }
};
</script>

<style></style>
